const mutations = {
  setModels(state, data) {
    state.turnoExamenes = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.turnoExamen = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.turnoExamenes.unshift(model);
  },

  updateModel(state, model) {
    state.turnoExamen = model;
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.turnoExamenes
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.turnoExamenes.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
